import { VINYL_COLORS } from '@cowell/shared';

import { useConfig } from '../state/hooks.js';
import { useConfigStore } from '../state/store.js';

export function VinylColorPicker() {
  const config = useConfig();
  const setVinylColor = useConfigStore((s) => s.setVinylColor);

  return (
    <fieldset className="section">
      <legend className="section-legend">Lettering color</legend>

      <div className="swatches" role="radiogroup" aria-label="Vinyl color">
        {VINYL_COLORS.map((c) => {
          const selected = config.vinylColorId === c.id;
          return (
            <button
              key={c.id}
              type="button"
              role="radio"
              aria-checked={selected}
              aria-label={`${c.displayName}${c.reflective ? ' (reflective)' : ''}`}
              title={c.displayName}
              className={`swatch${selected ? ' swatch--selected' : ''}${c.reflective ? ' swatch--reflective' : ''}`}
              onClick={() => setVinylColor(c.id)}
            >
              <span
                className="swatch__color"
                style={{ backgroundColor: c.hex }}
                aria-hidden="true"
              />
              <span className="swatch__name">{c.displayName}</span>
              {c.reflective ? (
                <span className="swatch__badge" aria-hidden="true">
                  reflective
                </span>
              ) : null}
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
